
import jsPDF, { jsPDFAPI } from "jspdf";
import { BasePDFNode, getYoga, RectPDFNode, RectStyle, TextPDFNode } from "./BasePDFNode";
import { RangedKanaal, RangedKanaalAssign } from "../props/PropTypes";
import { Kaart } from "../kanaal/hdw-config/HdwSysteem";
import { getAssignment, kanaalLabelHdw } from "../kanaal/kanaal.utils";
import { FlexDirectionStr } from "./FlexStyle";
import { get } from "http";

export class IOSlot extends RectPDFNode {
    constructor(public pdf: jsPDF, public a: string, public b: string, public fillBolt: boolean = false) {
        super(pdf, {
            flexDirection: 'row',
            alignItems: "center",
            justifyContent: "space-between",

            width: 15,
            height: 4
        }, getYoga().Node.create());
    }
    public init(): void {
        let ac = this.addChild2(new TextPDFNode(this.pdf, {
            // height:4
            marginLeft: 1,

        }));
        ac.text = this.a;
        let bc = this.addChild2(new TextPDFNode(this.pdf, {
            // fillColor: "#00E000",
            flexGrow: 1,
            marginRight: 1,
            // height:4   
            align: "right"
        }));
        bc.text = this.b;
        this.addChild2(new BoltPDFNode(this.pdf, {
            marginRight: 1,
            width: 2,
            height: 2,
            fillColor: this.fillBolt ? "#000000" : undefined
        }));
        super.init();

    }
}

export class IOLine extends BasePDFNode {
    constructor(public pdf: jsPDF, public ac: RangedKanaalAssign[], public a: string, public b: string, public fillBolt: boolean = false, public rotated: boolean = false) {
        super(pdf, {
            flexDirection: rotated ? 'row-reverse' : 'row',
            flexWrap: "wrap",
            maxWidth: 98,
            // alignItems: "flex-end",
            columnGap: 3
        }, getYoga().Node.create())
    }

    public init(): void {
        let textWidth = 60;
        if (this.style.maxWidth != undefined && typeof this.style.maxWidth === 'number') {
            textWidth = this.style.maxWidth - 37;
        }

        let c1 = this.addChild2(new IOSlot(this.pdf, this.a, this.b, this.fillBolt));
        let c2 = this.addChild2(new TextPDFNode(this.pdf, {
            width: 15,
            // fillColor: '#f0f000'
            // height:4

        }));
        let c3 = this.addChild2(new TextPDFNode(this.pdf, {
            // height:4,
            // borderWidth: 1,
            // fillColor: '#f00000',
            width: textWidth

        }));
        if (this.ac.length > 0) {
            c2.text = this.ac[0].assignement.afdeling;
            c3.text = this.ac[0].assignement.omschrijving;
        }
        if (this.ac.length > 1) {
            this.style.marginBottom = 3;
            this.style.rowGap = 1;
            for (let i = 1; i < this.ac.length; i++) {
                let ac = this.ac[i];
                let c2_1 = this.addChild2(new TextPDFNode(this.pdf, {
                    width: 15,
                    align: "right",
                    paddingRight: 1
                    // height:4

                }));
                c2_1.text = '--"--';
                let c2_2 = this.addChild2(new TextPDFNode(this.pdf, {
                    width: 15,
                    // fillColor: '#f0f000'
                    // height:4

                }));
                let c2_3 = this.addChild2(new TextPDFNode(this.pdf, {
                    // height:4,
                    // borderWidth: 1,
                    // fillColor: '#f00000',
                    width: textWidth

                }));
                c2_2.text = ac.assignement.afdeling;
                c2_3.text = ac.assignement.omschrijving;
            }
        }
        super.init();
    }

    public render(): void {
        super.render();
    }

}


export type Orientation = "left" | "right" | "up" | "down";
function isHorizontal(orientation: Orientation): boolean {
    return orientation == "left" || orientation == "right";
}
function isVertical(orientation: Orientation): boolean {
    return orientation == "up" || orientation == "down";
}


export class JumperNode extends BasePDFNode {

    constructor(public pdf: jsPDF, public labels: string[],public orientation: Orientation = "right", public position: number = 0) {
        super(pdf, {
            flexDirection: 'column',
        }, getYoga().Node.create());
    }

    public init(): void {
        let labelContainer = this.addChild2(new RectPDFNode(this.pdf, {
            flexDirection: this.orientation == "right" ? 'row' : 'row-reverse',
            justifyContent: "space-between",
            height: 4,
            columnGap: 0
        }));
        for (let i = 0; i < this.labels.length; i++) {
            let rc = labelContainer.addChild2(new RectPDFNode(this.pdf, {
                fillColor: "#70cc70",
                flexDirection: 'column',
                width: 4,
                height: 4,
                
            }));
            rc.style.alignItems = "center";
            let label = rc.addChild2(new TextPDFNode(this.pdf, {
                fontSize: 8,
                textColor: '#FFFFFF',
            }));
            label.text = this.labels[i];
        }
        let jumperContainer = this.addChild2(new RectPDFNode(this.pdf, {
            flexDirection: this.orientation == "right" ? 'row' : 'row-reverse',
            justifyContent: "space-between",
            height: 4,
            columnGap: 0
        }));
        for (let i = 0; i < this.labels.length; i++) {
            let isSet = i == this.position || i - 1 == this.position;
            let rc = jumperContainer.addChild2(new RectPDFNode(this.pdf, {
                fillColor: isSet ? "#000000" : "#ffffff",
                flexDirection: 'column',
                width: 4,
                height: 4,
                
            }));

        }
        
        super.init();
    }
}
export class DipSwitch extends BasePDFNode {
    constructor(public pdf: jsPDF, public dip: number, public bits: number = 6, public orientation: Orientation = "left",
        public colors: { numbers: string, on: string } = { numbers: '#b22222', on: "22b222" }) {
        super(pdf, {
            flexDirection: 'column',
            rowGap: 1,
            width: isVertical(orientation) ? undefined : 18,
            height: isVertical(orientation) ? 18 : undefined
            // height: 3
        }, getYoga().Node.create())
    }
    public init(): void {
        let dipText = this.addChild2(new TextPDFNode(this.pdf, {
            alignSelf: "flex-end",
        }));
        dipText.text = `Dip: ${this.dip}`;
        let cmainDirection: FlexDirectionStr = 'row';
        switch (this.orientation) {
            case "left":
                cmainDirection = 'row';
                break;
            case "right":
                cmainDirection = 'row-reverse';
                break;
            case "up":
                cmainDirection = 'column-reverse';
                break;
            case "down":
                cmainDirection = 'column';
                break;
        }
        let cmain = this.addChild2(new RectPDFNode(this.pdf, {
            flexDirection: cmainDirection,
            fillColor: this.colors.numbers,
            width: isVertical(this.orientation) ? undefined : 18,
            height: isVertical(this.orientation) ? 18 : undefined
            // height: 3
        }))
        let c1Direction: FlexDirectionStr = 'row';
        switch (this.orientation) {
            case "left":
                c1Direction = 'column';
                break;
            case "right":
                c1Direction = 'column-reverse';
                break;
            case "up":
                c1Direction = 'row';
                break;
            case "down":
                c1Direction = 'row-reverse';
                break;
        }
        let c1 = cmain.addChild2(new BasePDFNode(this.pdf, {
            flexDirection: c1Direction,
            // flexDirection: isVertical(this.orientation) ? 'row' : 'column',

        }));
        let c2 = cmain.addChild2(new RectPDFNode(this.pdf, {
            // flexDirection: isVertical(this.orientation) ? 'row' : 'column',
            flexDirection: c1Direction,
            fillColor: this.colors.on

        }));
        let textMargin: { left?: number, top?: number, bottom?: number, right?: number } = {
            left: 1,
            bottom: 1,
        }
        switch (this.orientation) {
            case "left":
                textMargin = {
                    left: 2,
                    top: -2,
                }
                break;
            case "right": {
                textMargin = {
                    right: 0,
                    left: 2,
                    bottom: 5,
                }
                break;
            }
            case "up":
                textMargin = {
                    left: 1,
                    bottom: 1,
                    top: 1,
                }
                break;
            case "down":
                textMargin = {
                    left: 1,
                    bottom: 1,
                    top: 1
                }
                break;

        }
        let on = c2.addChild2(new TextPDFNode(this.pdf, {
            vertical: isHorizontal(this.orientation),
            textColor: '#FFFFFF',
            alignSelf: "baseline",
            // fillColor: "00ffff",

            marginLeft: textMargin.left,
            marginBottom: textMargin.bottom,
            marginTop: textMargin.top,
            marginRight: textMargin.right

            // marginLeft: isVertical(this.orientation) ? 1 : 2,
            // marginTop: isVertical(this.orientation) ? undefined : -2,
            // marginBottom: isVertical(this.orientation) ? 1 : undefined,

        }));
        if (this.bits > 1) {
            on.text = "On";
        }
        for (let i = 0; i < this.bits; i++) {
            let bit = (this.dip >> i) & 1;
            let onColor = '#000000';
            let offColor = '#ffffff';
            let r = c1.addChild2(new BasePDFNode(this.pdf, {
                // width: 15,
                width: isVertical(this.orientation) ? 3 : undefined,
                height: isVertical(this.orientation) ? undefined : 3,
                flexDirection: cmainDirection,

            }));

            let nr = r.addChild2(new TextPDFNode(this.pdf, {
                marginLeft: 1,
                textColor: '#FFFFFF'
            }));
            if (this.bits > 1) {
                nr!.text = (i + 1).toString();
            }
            r.addChild2(new RectPDFNode(this.pdf, {
                width: isVertical(this.orientation) ? undefined : 5,
                height: isVertical(this.orientation) ? 5 : undefined,
                // height: 3
                fillColor: bit == 1 ? offColor : onColor
            }));
            r.addChild2(new RectPDFNode(this.pdf, {
                width: isVertical(this.orientation) ? undefined : 5,
                height: isVertical(this.orientation) ? 5 : undefined,
                // height: 3,
                fillColor: bit == 1 ? onColor : offColor
            }));
        }
    }
}


export class BoltPDFNode extends RectPDFNode {
    constructor(public pdf: jsPDF, public style: Partial<RectStyle> = {}, private dot: boolean = false) {
        super(pdf, style);
    }

    public render(): void {
        let l = this.layout.getComputedLayout();
        let topLeft = this.getTopLeft();

        let style = "S";
        let draw = false;
        if (this.rectStyle.fillColor != undefined) {
            style = "FD";
            this.pdf.setFillColor(this.rectStyle.fillColor);
            draw = true;
        }
        if (this.rectStyle.borderColor != undefined) {
            this.pdf.setDrawColor(this.rectStyle.borderColor);
            draw = true;
        }
        if (draw) {
            let r = Math.min(l.width, l.height) / 2;
            let center = {
                x: topLeft.x + l.width / 2,
                y: topLeft.y + l.height / 2
            };
            this.pdf.circle(center.x, center.y, r, style);
            let lineStart = {
                x: center.x - Math.sqrt(2) / 2 * r,
                y: center.y - Math.sqrt(2) / 2 * r
            };
            let lineEnd = {
                x: center.x + Math.sqrt(2) / 2 * r,
                y: center.y + Math.sqrt(2) / 2 * r
            }
            if (this.dot) {
                this.pdf.circle(center.x, center.y, 0.5, style);
            } else {
                this.pdf.line(lineStart.x, lineStart.y, lineEnd.x, lineEnd.y);
            }


        }
        //super.render();
    }
}

